import { createFileRoute } from '@tanstack/react-router'
import ShareReport from '../../../../../../../containers/Reports/components/ShareReport'

export const Route = createFileRoute(
  '/_authenticated/project/$projectId/reports/share/$reportId/'
)({
  component: ShareReport
})
